import * as Yup from "yup";

const SportGroupCategoryProductSchema = () => Yup.object().shape({
  sport_id: Yup
    .number()
    .label("Sport")
    .required(),
  product_group_id: Yup
    .number()
    .label("Product Group")
    .required(),
  parent_product_category_id: Yup
    .number()
    .label("Parent Product Category")
    .nullable(),
  product_category_id: Yup
    .number()
    .label("Product Category")
    .nullable(),
  product_id: Yup
    .number()
    .label("Product")
    .required(),
});

export default SportGroupCategoryProductSchema;
